import { createTheme, alpha } from '@mui/material/styles';

const IDN_PURPLE = '#6B21A8';
const IDN_PURPLE_LIGHT = '#9333EA';
const IDN_PURPLE_DARK = '#4C1D95';
const IDN_GRAY = '#1E1B2E';

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: IDN_PURPLE,
      light: IDN_PURPLE_LIGHT,
      dark: IDN_PURPLE_DARK,
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#06B6D4',
      light: '#67E8F9',
      dark: '#0E7490'
    },
    background: {
      default: '#F5F3FF',
      paper: '#FFFFFF'
    },
    text: {
      primary: IDN_GRAY,
      secondary: '#6B7280'
    },
    success: { main: '#10B981' },
    warning: { main: '#F59E0B' },
    error: { main: '#EF4444' },
    info: { main: '#3B82F6' }
  },
  typography: {
    fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
    h1: { fontWeight: 800, letterSpacing: '-0.025em' },
    h2: { fontWeight: 700, letterSpacing: '-0.025em' },
    h3: { fontWeight: 700, letterSpacing: '-0.02em' },
    h4: { fontWeight: 700 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, textTransform: 'none', letterSpacing: '0.01em' }
  },
  shape: { borderRadius: 12 },
  shadows: [
    'none',
    '0px 1px 3px rgba(107,33,168,0.06), 0px 1px 2px rgba(107,33,168,0.04)',
    '0px 4px 6px -1px rgba(107,33,168,0.08), 0px 2px 4px -2px rgba(107,33,168,0.06)',
    '0px 10px 15px -3px rgba(107,33,168,0.1), 0px 4px 6px -4px rgba(107,33,168,0.08)',
    '0px 20px 25px -5px rgba(107,33,168,0.1), 0px 8px 10px -6px rgba(107,33,168,0.08)',
    ...Array(20).fill('none')
  ],
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        body { background: #F5F3FF; }
        ::-webkit-scrollbar { width: 6px; height: 6px; }
        ::-webkit-scrollbar-track { background: #F5F3FF; }
        ::-webkit-scrollbar-thumb { background: ${IDN_PURPLE}33; border-radius: 3px; }
        ::-webkit-scrollbar-thumb:hover { background: ${IDN_PURPLE}66; }
      `
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: '8px 20px',
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' }
        },
        contained: {
          background: `linear-gradient(135deg, ${IDN_PURPLE_LIGHT}, ${IDN_PURPLE_DARK})`,
          '&:hover': { background: `linear-gradient(135deg, ${IDN_PURPLE}, ${IDN_PURPLE_DARK})` }
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0px 4px 20px rgba(107,33,168,0.06)',
          border: '1px solid rgba(107,33,168,0.06)'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: { borderRadius: 8, fontWeight: 600, fontSize: '0.72rem' }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: alpha(IDN_PURPLE, 0.04),
            fontWeight: 700,
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            color: IDN_PURPLE_DARK,
            borderBottom: `2px solid ${alpha(IDN_PURPLE, 0.12)}`
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:hover': { backgroundColor: alpha(IDN_PURPLE, 0.02) },
          '&:last-child td': { border: 0 }
        }
      }
    },
    MuiTextField: {
      defaultProps: { size: 'small', variant: 'outlined' }
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          background: `linear-gradient(180deg, ${IDN_GRAY} 0%, #2D1B4E 100%)`,
          border: 'none'
        }
      }
    }
  }
});
